import { CSSProperties } from "react";
import { useNavigate } from "react-router-dom";

type LoginRole = "restoran" | "kurye" | "garson";

interface Props {
  active: LoginRole;
}

const ROLES: { key: LoginRole; label: string; icon: string; path: string }[] = [
  { key: "restoran", label: "Restoran", icon: "bi-shop", path: "/" },
  { key: "kurye", label: "Kurye", icon: "bi-bicycle", path: "/DriverLogin" },
  { key: "garson", label: "Garson", icon: "bi-person-badge", path: "/WaiterLogin" },
];

export default function LoginRoleSwitch({ active }: Props) {
  const navigate = useNavigate();

  const baseStyle: CSSProperties = {
    flex: 1, padding: "9px 0", borderRadius: 9, border: "none", cursor: "pointer",
    fontWeight: 700, fontSize: "0.85rem", transition: "all 0.15s",
    display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
  };

  return (
    <div style={{ display: "flex", background: "#f3f4f6", borderRadius: 12, padding: 4, marginBottom: 24 }}>
      {ROLES.map((r) => (
        <button
          key={r.key}
          type="button"
          onClick={() => { if (r.key !== active) navigate(r.path); }}
          style={{
            ...baseStyle,
            background: active === r.key ? "#fff" : "transparent",
            color: active === r.key ? "#111827" : "#6b7280",
            boxShadow: active === r.key ? "0 1px 4px rgba(0,0,0,0.08)" : "none",
          }}
        >
          <i className={`bi ${r.icon}`}></i> {r.label}
        </button>
      ))}
    </div>
  );
}
